import moment from "moment/moment";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

const parseDate = (dateStr, fieldName) => moment(moment.utc(dateStr[fieldName]).format(DATE_FORMAT.monthAbbrDatePadded)).startOf("day");

const shouldDeleteRow = ({ startDateSetup, endDateSetup, tableDateValue, fromValue, toValue, type, columnTableValue }) => {
	if (!columnTableValue) {
		if (type === "to") {
			return endDateSetup.isBefore(fromValue);
		} else {
			return startDateSetup.isAfter(toValue);
		}
	}

	if (columnTableValue === "from" && type === "to") {
		return endDateSetup.isBefore(tableDateValue);
	} else if (columnTableValue === "to" && type === "from") {
		return startDateSetup.isAfter(tableDateValue);
	}

	return false;
};

const shouldUpdateRow = ({ startDateSetup, endDateSetup, fromDateValue, toDateValue, type, columnTableValue }) => {
	if (columnTableValue === "from") {
		if (type === "to") {
			return endDateSetup.isBefore(toDateValue);
		} else {
			return startDateSetup.isAfter(fromDateValue);
		}
	} else if (columnTableValue === "to") {
		if (type === "to") {
			return endDateSetup.isAfter(toDateValue);
		} else {
			return startDateSetup.isBefore(fromDateValue);
		}
	}

	if (type === "to") {
		return endDateSetup.isSameOrBefore(toDateValue) && endDateSetup.isSameOrAfter(fromDateValue);
	} else {
		return startDateSetup.isAfter(fromDateValue) && startDateSetup.isSameOrBefore(toDateValue);
	}
};

const processRows = ({ tableRows, startDateSetup, endDateSetup, effecDateFromFieldName, effecDateToFieldName, type }) => {
	const rowsToBeUpdated = [];
	const rowsToBeDeleted = [];

	const isBothValues = effecDateFromFieldName && effecDateToFieldName;
	const fromOrTo = effecDateFromFieldName && !effecDateToFieldName ? "from" : "to";
	const columnTableValue = isBothValues ? null : fromOrTo;

	tableRows?.forEach((row) => {
		const fromDateValue = effecDateFromFieldName ? parseDate(row, effecDateFromFieldName) : null;
		const toDateValue = effecDateToFieldName ? parseDate(row, effecDateToFieldName) : null;

		if (
			shouldDeleteRow({
				startDateSetup,
				endDateSetup,
				type,
				columnTableValue,
				tableDateValue: fromDateValue || toDateValue,
				fromValue: fromDateValue,
				toValue: toDateValue,
			})
		) {
			rowsToBeDeleted.push(row);
		} else if (shouldUpdateRow({ startDateSetup, endDateSetup, fromDateValue, toDateValue, type, columnTableValue })) {
			rowsToBeUpdated.push(row);
		}
	});

	return { rowsToBeDeleted, rowsToBeUpdated };
};

const getRowsToBeDeletedAndUpdated = ({ tableRows, fromDate, toDate, effecDateFromFieldName, effecDateToFieldName, type }) => {
	const startDateSetup = moment(fromDate).startOf("day");
	const endDateSetup = moment(toDate).endOf("day");

	return processRows({ tableRows, startDateSetup, endDateSetup, effecDateFromFieldName, effecDateToFieldName, type });
};
const cleanRowsState = (apiRef, rows) => {
	rows.forEach((row) => {
		if (row) {
			apiRef.current.selectRow(row, false);
		}
	});
};

const highlightRowsToBeDeleted = (apiRef, rowsToDelete) => {
	if (apiRef) {
		rowsToDelete.forEach((row) => {
			if (row?._id) {
				apiRef.current.selectRow(row._id);
			}
		});
	}
};

export { getRowsToBeDeletedAndUpdated, cleanRowsState, highlightRowsToBeDeleted };
